/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Dictate_Error_Too_LongInputs */



/**
* | output |
* | --- |
* | "This recording is too long to transcribe. Please record a shorter message." |
*
* @param {Chat_Dictate_Error_Too_LongInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_dictate_error_too_long = /** @type {((inputs?: Chat_Dictate_Error_Too_LongInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dictate_Error_Too_LongInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Aufnahme ist zu lang für die Transkription. Bitte nimm eine kürzere Nachricht auf.")
	return /** @type {LocalizedString} */ ("This recording is too long to transcribe. Please record a shorter message.")
});